// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2cGYG","header":"ReportDetails_header__236WA","title":"ReportDetails_title__2tgEI","left":"ReportDetails_left__2inFw"};